
import './App.css';
import { RouterProvider } from 'react-router-dom';
import router from './Routes/Route';
 
function App() {

  return (
    <div className=' break-all'>
      
      <RouterProvider router={router}/>
       
    </div>
  );
}

export default App;
